import datalinkApis from "@/api/datalink";
import axios from "axios";

const uploadFile = async (files, fileMeta, urls, commit) => {
  let newAxiosInstance = axios.create();
  delete newAxiosInstance.defaults.headers.common["Authorization"];
  const promises = urls.map(async (url, index) => {
    const options = {
      headers: {
        "Content-Type": fileMeta[index].type,
      },
      onUploadProgress: function (progressEvent) {
        const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        commit("progressUploadFile", {
          index: index,
          progress,
        });
      },
    };
    return newAxiosInstance.put(url, files[index], options);
  });
  return Promise.all(promises);
};
const historyTableSettingDefault = () => {
  return {
    currentPage: 1,
    numberOfItemPerPage: 10,
    totalNumber: 0,
    isLoading: false,
  };
};
const state = {
  historyList: [],
  historyTableSetting: historyTableSettingDefault(),
  details: null,
  progressByIndividualFile: [],
};
const getters = {
  historyList: (state) => {
    return state.historyList;
  },
  uploadingFilesProgress: (state) => {
    return state.progressByIndividualFile;
  },
  details: (state) => {
    return state.details;
  },
  historyTableSetting: (state) => {
    return state.historyTableSetting;
  },
};
const actions = {
  async fetchDetails({ commit, rootGetters }, fileTimestamp) {
    commit("resetDetails");
    const storeKey = rootGetters["user/getCurrentStoreKey"];
    const details = await datalinkApis.getDetails(storeKey, fileTimestamp);
    commit("setDetails", details);
  },
  async changeHistoryPageNumber({ commit, dispatch }, newPageNumber) {
    if (newPageNumber > 0) {
      commit("changeHistoryPageNumber", newPageNumber);
      dispatch("fetchHistory");
    }
  },
  async refetchHistory({ commit, dispatch }) {
    commit("resetHistorySetting");
    dispatch("fetchHistory");
  },
  async fetchHistory({ commit, state, rootGetters }, silentUpdate = false) {
    const storeKey = rootGetters["user/getCurrentStoreKey"];
    if (!silentUpdate) {
      commit("changeHistoryLoadingStatus", true);
    }
    const history = await datalinkApis.getHistory(
      storeKey,
      state.historyTableSetting.currentPage,
      state.historyTableSetting.numberOfItemPerPage
    );
    commit("setHistoryList", history.data);
    commit("setTotalNumberOfHistory", history.total_num);
    if (!silentUpdate) {
      commit("changeHistoryLoadingStatus", false);
    }
  },
  async uploadFilesToS3({ rootGetters, dispatch, commit }, payload) {
    const { files, fileMeta } = payload;
    const storeKey = rootGetters["user/getCurrentStoreKey"];
    try {
      commit("setUploadFilesStatus", fileMeta.length);
      const urls = await datalinkApis.getSignedUrl(storeKey, fileMeta);
      await uploadFile(files, fileMeta, urls, commit);
      dispatch("fetchHistory");
    } catch (e) {
      throw new Error(e);
    }
  },
  async deleteHistory({ rootGetters, dispatch }, fileTimeStamp) {
    const storeKey = rootGetters["user/getCurrentStoreKey"];
    await datalinkApis.deleteHistory(storeKey, fileTimeStamp);
    dispatch("fetchHistory");
  },
  async sendToVirtusize({ rootGetters, dispatch }, fileTimeStamp) {
    const storeKey = rootGetters["user/getCurrentStoreKey"];
    await datalinkApis.sendToVirtusize(storeKey, fileTimeStamp);
    dispatch("fetchDetails", fileTimeStamp);
  },
};
const mutations = {
  resetModule(state) {
    state.historyList = [];
    state.details = null;
    state.progressByIndividualFile = [];
  },
  setHistoryList(state, historyList) {
    state.historyList = historyList;
  },
  setTotalNumberOfHistory(state, totalNum) {
    state.historyTableSetting = {
      ...state.historyTableSetting,
      totalNumber: totalNum,
    };
  },
  changeHistoryPageNumber(state, newPageNumber) {
    state.historyTableSetting = {
      ...state.historyTableSetting,
      currentPage: newPageNumber,
    };
  },
  changeHistoryLoadingStatus(state, loadingStatus) {
    state.historyTableSetting = {
      ...state.historyTableSetting,
      isLoading: loadingStatus,
    };
  },
  resetHistorySetting(state) {
    state.historyTableSetting = historyTableSettingDefault();
  },
  resetUploadFilesStatus(state) {
    state.progressByIndividualFile = [];
  },
  setUploadFilesStatus(state, maxNum) {
    state.progressByIndividualFile = new Array(maxNum).fill(0);
  },
  progressUploadFile(state, payload) {
    const { index, progress } = payload;
    state.progressByIndividualFile = [...state.progressByIndividualFile];
    state.progressByIndividualFile[index] = progress;
  },
  resetDetails(state) {
    state.details = null;
  },
  setDetails(state, details) {
    state.details = details;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
